// extracted by mini-css-extract-plugin
export default {"IconButton":"SearchButton-module__IconButton__uGkXY5u"};